/**
 * Configuración centralizada de idiomas soportados.
 * Usado en LanguageSwitcher, i18n config, y componentes de traducción.
 */

export type SupportedLanguage = "es" | "en" | "pt" | "de" | "fr";

export interface LanguageConfig {
  code: SupportedLanguage;
  name: string;
  nativeName: string;
  flag: string;
}

export const SUPPORTED_LANGUAGES: LanguageConfig[] = [
  {
    code: "es",
    name: "Spanish",
    nativeName: "Español",
    flag: "🇪🇸",
  },
  {
    code: "en",
    name: "English",
    nativeName: "English",
    flag: "🇺🇸",
  },
  {
    code: "pt",
    name: "Portuguese",
    nativeName: "Português",
    flag: "🇧🇷",
  },
  {
    code: "de",
    name: "German",
    nativeName: "Deutsch",
    flag: "🇩🇪",
  },
  {
    code: "fr",
    name: "French",
    nativeName: "Français",
    flag: "🇫🇷",
  },
];

export const DEFAULT_LANGUAGE: SupportedLanguage = "es";
export const FALLBACK_LANGUAGE: SupportedLanguage = "en";

/**
 * Obtiene la configuración de un idioma por su código.
 */
export function getLanguageConfig(
  code: string
): LanguageConfig | undefined {
  const normalized = code.toLowerCase().slice(0, 2);
  return SUPPORTED_LANGUAGES.find((lang) => lang.code === normalized);
}

/**
 * Verifica si un código de idioma es soportado.
 */
export function isLanguageSupported(code: string): boolean {
  return getLanguageConfig(code) !== undefined;
}

/**
 * Normaliza un código de idioma a uno soportado.
 * Si no es soportado, devuelve el idioma por defecto.
 */
export function normalizeLanguageCode(code: string): SupportedLanguage {
  const config = getLanguageConfig(code);
  return config?.code ?? DEFAULT_LANGUAGE;
}
